import SquareTagsGridComponent from "segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-component";
import { componentStyles } from "./product-tags-component.scss";
import { buttonConfigByProduct } from "../consts";

const ProductTagsComponent = (props) => {
  const { currentTab, isV2, excludeFromWMHighIntentExperienceTest } = props;

  const BUTTON_CONFIG_BY_PRODUCT = buttonConfigByProduct(isV2, excludeFromWMHighIntentExperienceTest);

  return (
    <div className="product-tags-component">
      <SquareTagsGridComponent
        clusters={currentTab?.tabContent?.clusters}
        buttonConfig={{
          ...BUTTON_CONFIG_BY_PRODUCT[currentTab.productType],
          removeGradient: currentTab?.productType !== "work-management"
        }}
        showBorderInLightTheme={true}
        productType={currentTab?.productType}
      />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ProductTagsComponent;
